<template lang="pug">
  BaseTable(
    :title="title"
    :routeKey="routeKey"
    :routes="routes"
    :table="table"
    :items="items"
    :meta="meta"
    :sort="sort"
    :page="page"
    :onDelete="onDelete"
    :toggleSort="toggleSort"
    :changePage="changePage"
  )
</template>

<script>
import BaseTable from '@/components/app/BaseTable'
import store from '@/store'
import { mapState, mapMutations } from 'vuex'

export default {
  components: { BaseTable },
  data: vm => ({
    title: vm.$t('media.title')
  }),
  computed: {
    ...mapState('ridersMedia', ['routeKey', 'routes', 'table', 'items', 'meta', 'sort', 'page']),
    crumbs: vm => [
      { text: vm.$t('riders.title'), to: { name: 'riders.index' } },
      { text: vm.$t('riders.edit', { id: vm.$route.params.riderId }), to: { name: 'riders.edit' } },
      { text: vm.$t('media.title') }
    ]
  },
  async beforeRouteEnter (to, from, next) {
    try {
      await store.dispatch('ridersMedia/fetchItems', { route: to })
      next()
    } catch (error) {
      next(error)
    }
  },
  methods: {
    ...mapMutations('ridersMedia', ['SET_SORT', 'SET_PAGE']),
    async onDelete (id) {
      await store.dispatch('ridersMedia/deleteItem', { route: this.$route, id })
      await store.dispatch('ridersMedia/fetchItems', { route: this.$route })
      this.$notify({ message: this.$t('forms.notify.deleted') })
    },
    async toggleSort (field) {
      this.SET_SORT(field)
      await store.dispatch('ridersMedia/fetchItems', { route: this.$route })
    },
    async changePage (page) {
      this.SET_PAGE(page)
      await store.dispatch('ridersMedia/fetchItems', { route: this.$route })
    }
  }
}
</script>
